import { createContext } from 'react';

import { Dispatch, Action } from 'redux';

import {
  UserDashboards,
  WidgetItem,
  Team,
  LocationAndTeamsFilterState,
  ChatUser,
} from '@vyce/core/src/types';
import { WidgetWrapperProps } from '../components/Dashboard/WidgetWrapper';
import { TeamsReportClientApp } from '../api/reports/teamsReports';
import { getStaffRequest } from '../api/companies';

interface Context {
  dashboards?: UserDashboards;
  first_name?: string;
  teams?: Team[];
  companyDataLoading: boolean;
  selectedCompanyId: string;
  timePermission: boolean;
  teamPermission: boolean;
  mainDashboardFilters: LocationAndTeamsFilterState | undefined;
  updateMainDashboardFilters: (filters: LocationAndTeamsFilterState) => void;
  widgetComponent: (props: { widget: WidgetItem; redirectUrl?: string } & WidgetWrapperProps) => JSX.Element;
  inviteButtonComponent?: () => JSX.Element;
  updateUserDashboards: (dashboards: UserDashboards) => (dispatch: Dispatch<Action>) => Promise<void>;
  onOpenUniversalInviteForm?: () => void;
  chatUser?: ChatUser;
  chatCompanyId?: string;
  chatRoute?: string;
  /** "Request report": which app the notification links open, and who can be a recipient. */
  reports?: {
    clientApp: TeamsReportClientApp;
    currentUserId?: string;
    companyName?: string;
    getStaff?: typeof getStaffRequest;
  };
}

export const TeamsDashboardModuleContext = createContext({} as Context);

export const TeamsDashboardModuleProvider = TeamsDashboardModuleContext.Provider;
